<div class="product-advanced-carousel">
  <div
    (next)="trackRightSwipe()"
    (previous)="trackLeftSwipe()"
    *ngIf="isMobile"
    appSwipe
    class="product-advanced-carousel__mobile"
  >
    <ng-container *ngFor="let product of products; trackBy: trackById; let i = index; let last = last">
      <app-search-product-card-variants
        (productClick)="onProductClick($event.product, $event.priceType, i)"
        [addToCartConfig]="addToCartConfig"
        [isBlackDealsEnabled]="isBlackDealsEnabled$ | async"
        [isDesktop]="isDesktop"
        [isMobileOrTablet]="!isDesktop"
        [isProductList]="false"
        [title]="title"
        [trackingName]="trackingName"
        [isSimilarProductRecommendation]="false"
        [product]="product"
        [shouldSaveSpaceForVariants]="someProductHasVariants()"
        [fromCarousel]="true"
        [style.margin-right.px]="last && hasEndPadding  ? '16' : '0'"
        class="product-advanced-carousel__mobile__card"
        test-target="product-carousel-item-mobile"
      >
      </app-search-product-card-variants>
    </ng-container>
  </div>
  <div
    appDesktopSwipe
    *ngIf="!isMobile" class="product-advanced-carousel__desktop"
  >
    <span
      data-name="left-arrow"
      (click)="onProductCarouselPrev()"
      [mmTestTarget]="'product-carousel-carousel-prev-button'"
      class="product-advanced-carousel__desktop__arrow"
    >
      <mm-icon name="chevron-small-left"></mm-icon>
    </span>
    <ng-container *ngFor="let product of products; trackBy: trackById; let i = index; let last = last">
      <app-search-product-card-variants
        (productClick)="onProductClick($event.product, $event.priceType, i)"
        [addToCartConfig]="addToCartConfig"
        [isBlackDealsEnabled]="isBlackDealsEnabled$ | async"
        [isDesktop]="isDesktop"
        [isMobileOrTablet]="!isDesktop"
        [isProductList]="false"
        [title]="title"
        [trackingName]="trackingName"
        [isSimilarProductRecommendation]="false"
        [productIndex]="i"
        [product]="product"
        [saveTotalUnitsOrBasePriceSpace]="someProductsHasTotalUnitsOrBasePrice()"
        [shouldSaveSpaceForVariants]="someProductHasVariants()"
        [fromCarousel]="true"
        [style.margin-right.px]="last && hasEndPadding  ? '16' : '0'"
        class="product-advanced-carousel__desktop__card"
        [ngClass]="{
          'product-advanced-carousel__desktop__card--large': products.length <= 5,
          'product-advanced-carousel__desktop__card--small': products.length > 5
        }"
        test-target="product-carousel-item-mobile"
      >
      </app-search-product-card-variants>
    </ng-container>
    <span
      data-name="right-arrow"
      (click)="onProductCarouselNext()"
      [mmTestTarget]="'product-carousel-carousel-next-button'"
      class="product-advanced-carousel__desktop__arrow"
    >
      <mm-icon name="chevron-small-right"></mm-icon>
    </span>
  </div>
</div>
